"use strict";

exports.__esModule = true;
exports.ClippingAttachment = void 0;

var _Utils = require("../Utils");

var _Attachment = require("./Attachment");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** An attachment with vertices that make up a polygon used for clipping the rendering of other attachments. */
var ClippingAttachment = /*#__PURE__*/function (_VertexAttachment) {
  _inheritsLoose(ClippingAttachment, _VertexAttachment);

  function ClippingAttachment(name) {
    var _this;

    _this = _VertexAttachment.call(this, name) || this;
    /** Clipping is performed between the clipping polygon's slot and the end slot. Returns null if clipping is done until the end of
     * the skeleton's rendering. */

    _this.endSlot = null; // Nonessential.

    /** The color of the clipping polygon as it was in Spine. Available only when nonessential data was exported. Clipping polygons
     * are not usually rendered at runtime. */

    _this.color = new _Utils.Color(0.2275, 0.2275, 0.8078, 1); // ce3a3aff

    return _this;
  }

  var _proto = ClippingAttachment.prototype;

  _proto.copy = function copy() {
    var copy = new ClippingAttachment(this.name);
    this.copyTo(copy);
    copy.endSlot = this.endSlot;
    copy.color.setFromColor(this.color);
    return copy;
  };

  return ClippingAttachment;
}(_Attachment.VertexAttachment);

exports.ClippingAttachment = ClippingAttachment;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUE4QkE7O0FBQ0E7Ozs7OztBQUVBO0lBQ2FBLGtCOzs7RUFVWiw0QkFBYUMsSUFBYixFQUF5QjtJQUFBOztJQUN4QixxQ0FBTUEsSUFBTjtJQVZEOzs7SUFFQSxnQkFBb0IsSUFBcEIsQ0FPeUIsQ0FMekI7O0lBQ0E7OztJQUVBLGNBQVEsSUFBSUMsWUFBSixDQUFVLE1BQVYsRUFBa0IsTUFBbEIsRUFBMEIsTUFBMUIsRUFBa0MsQ0FBbEMsQ0FBUixDQUV5QixDQUZxQjs7SUFFckI7RUFFeEI7Ozs7U0FFREMsSSxHQUFBLGdCQUFJO0lBQ0gsSUFBSUEsSUFBSSxHQUFHLElBQUlILGtCQUFKLENBQXVCLEtBQUtDLElBQTVCLENBQVg7SUFDQSxLQUFLRyxNQUFMLENBQVlELElBQVo7SUFDQUEsSUFBSSxDQUFDRSxPQUFMLEdBQWUsS0FBS0EsT0FBcEI7SUFDQUYsSUFBSSxDQUFDRyxLQUFMLENBQVdDLFlBQVgsQ0FBd0IsS0FBS0QsS0FBN0I7SUFDQSxPQUFPSCxJQUFQO0VBQ0EsQzs7O0VBcEJzQ0ssNEIiLCJuYW1lcyI6WyJDbGlwcGluZ0F0dGFjaG1lbnQiLCJuYW1lIiwiQ29sb3IiLCJjb3B5IiwiY29weVRvIiwiZW5kU2xvdCIsImNvbG9yIiwic2V0RnJvbUNvbG9yIiwiVmVydGV4QXR0YWNobWVudCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXR0YWNobWVudHMvQ2xpcHBpbmdBdHRhY2htZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19